module.exports = __webpack_public_path__ + "static/media/loader.4b3413ca.svg";